import http from '../utils/request'

/** 获取作业列表（带搜索） */
export function getJobs(params = {}) {
  return http.get('/job/list', { params })
}

/** 获取作业详情 */
export function getJobById(guid) {
  return http.get(`/job/${guid}`)
}

/** 新增/编辑作业 */
export function saveJob(data) {
  return http.post('/job', data)
}

/** 删除作业 */
export function deleteJob(guid) {
  return http.delete(`/job/${guid}`)
}

/** 设置作业状态 (启用/停用) */
export function setJobStatus(guid, status) {
  return http.put(`/job/${guid}/status`, { status })
}

/** 手动触发执行 */
export function triggerJob(guid) {
  return http.post(`/job/${guid}/trigger`)
}

/** 获取执行日志 */
export function getJobLogs(guid, page = 1, pageSize = 50) {
  return http.get(`/job/${guid}/logs`, { params: { page, pageSize } })
}

/** 保存目录 */
export function saveJobFolder(data) {
  return http.post('/job/folder', data)
}

/** 获取作业目录树 */
export function getJobFolders() {
  return http.get('/job/folders')
}
